<template>
    <div>
        <div id="fb-root"></div>
        <div
                attribution="install_email"
                class="fb-customerchat"
                logged_in_greeting="Get in touch with our Bindez Customer Success Team! "
                logged_out_greeting="Get in touch with our Bindez Customer Success Team! "
                page_id="610261119001605"
                theme_color="#24A689"
        >
        </div>
    </div>
</template>

<script>
	export default {
		name: "CustomerChat",
		mounted() {
			window.fbAsyncInit = function () {
				FB.init({
					appId: 687337695199881,
					xfbml: true,
					version: 'v8.0'
				});
			};

			(function (d, s, id) {
				const fjs = d.getElementsByTagName(s)[0];
				if (d.getElementById(id)) return;
				const js = d.createElement(s);
				js.id = id;
				js.src = 'https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js';
				fjs.parentNode.insertBefore(js, fjs);
			}(document, 'script', 'facebook-jssdk'));
		}
	}
</script>

<style scoped>

</style>
